/* Per-person avatar tones (PB-5134, d36). Every avatar in the product picks a
 * gradient from this palette by a stable hash of its seed (a user id, or the
 * name when no id exists), so the same person always looks the same and two
 * people rarely look alike. Fills are mid-lightness design-system channels
 * and the initials use the shell channel, which reads on them in every theme.
 * Literal class strings so Tailwind sees them. */
export const AVATAR_TONES: readonly string[] = [
  "bg-linear-150 from-pb-accent to-pb-accent-active text-pb-accent-foreground",
  "bg-linear-150 from-pb-teal to-pb-cyan text-pb-shell",
  "bg-linear-150 from-pb-gold to-pb-amber text-pb-shell",
  "bg-linear-150 from-pb-iris-interactive to-pb-purple text-pb-primary-foreground",
  "bg-linear-150 from-pb-green to-pb-teal text-pb-shell",
  "bg-linear-150 from-pb-cyan to-pb-iris-interactive text-pb-primary-foreground",
];

/** A stable, small hash so a seed maps to the same tone on every render. */
export function avatarToneIndex(seed: string): number {
  let hash = 0;
  for (let index = 0; index < seed.length; index += 1) {
    hash = (hash * 31 + seed.charCodeAt(index)) >>> 0;
  }
  return hash % AVATAR_TONES.length;
}

export function avatarToneFor(seed: string | null | undefined): string {
  return AVATAR_TONES[avatarToneIndex(seed?.trim() || "?")] ?? AVATAR_TONES[0]!;
}
